import React from 'react';
import Headline from 'headline';
import Button from 'button';
import Img from 'img';
import Icon from 'icon';
import s from './suggest-infl.module.scss';

export default function SuggestInfl({ top3Infl, ...props }) {
  return (
    <div className={s.root}>
      <Headline className={s.title} title h2>
        Influencers Requested
      </Headline>
      <div className={s.wrapper}>
        {top3Infl?.map(
          ({ username, firstName, lastName, country, featuredImage }) => (
            <div className={s.inflWrapper}>
              <a href={`/influencers/${username}`} className={s.imgWrapper}>
                <Img
                  effect
                  className={s.featuredImg}
                  src={featuredImage}
                  alt={featuredImage?.id}
                />
              </a>
              <div className={s.textWrapper}>
                <Headline className={s.fullName}>
                  {`${firstName.replace(firstName[0], firstName[0].toUpperCase())} ${lastName.replace(lastName[0], lastName[0].toUpperCase())}`}
                </Headline>
                {username && (
                  <div className={`${s.flex} ${s.row} ${s.margin}`}>
                    <Icon className={s.icon} icon="link-chain" />
                    <a
                      className={s.text}
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`https://www.instagram.com/${username}`}
                      dangerouslySetInnerHTML={{ __html: `@${username}` }}
                    />
                  </div>
                )}
                {country?.name && (
                  <div className={`${s.flex} ${s.row}`}>
                    <Icon className={s.icon} icon="location-pin" />
                    <p
                      className={s.text}
                      dangerouslySetInnerHTML={{ __html: country?.name }}
                    />
                  </div>
                )}
              </div>
            </div>
          )
        )}
      </div>

      <Button
        className={s.button}
        href="/influencers/top-influencers-requested"
      >
        View all top requests
      </Button>
    </div>
  );
}
